import { createContext, useContext } from "react";

/** The default level of tile headings; `TileHeadingLevel` in tile.tsx sets it. */
export const TileHeadingContext = createContext<"h2" | "h3">("h2");

export function useTileHeadingLevel(): "h2" | "h3" {
  return useContext(TileHeadingContext);
}
